import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "HelpAndSupportBlock ActContentBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createTextVNode(" Questions about your modules? Visit our ", -1 /* CACHED */)),
    _createElementVNode("a", {
      class: "ActDashboardSupportLink",
      href: "#",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToHelpCentrePage && _ctx.navigateToHelpCentrePage(...args)))
    }, " Help Centre "),
    _cache[3] || (_cache[3] = _createTextVNode(" or ", -1 /* CACHED */)),
    _createElementVNode("a", {
      class: "ActDashboardSupportLink",
      href: "#",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToContactSupportPage && _ctx.navigateToContactSupportPage(...args)))
    }, " Contact Support "),
    _cache[4] || (_cache[4] = _createTextVNode(". ", -1 /* CACHED */))
  ]))
}